import { render, staticRenderFns } from "./UserProfilesReferral.vue?vue&type=template&id=7397d7ce&"
import script from "./UserProfilesReferral.vue?vue&type=script&lang=js&"
export * from "./UserProfilesReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports